import React from 'react'

import { MarqueeInteractive } from './marquee-interactive'
import { MarqueeStatic } from './marquee-static'

import type { RefAttributes } from 'react'

type MarqueeProps = {
  children: Array<React.ReactNode>
  variant: 'interactive' | 'static'
  paused?: boolean
} & RefAttributes<HTMLDivElement>

export const Marquee = React.forwardRef(
  (
    { children, variant, paused }: MarqueeProps,
    forwardedRef: React.ComponentPropsWithRef<'div'>['ref'],
  ) => {
    const Cmp = variant === 'interactive' ? MarqueeInteractive : MarqueeStatic

    return (
      <Cmp ref={forwardedRef} paused={paused}>
        {children}
      </Cmp>
    )
  },
)
